// Global error handler for debugging - must be FIRST
if (typeof window !== 'undefined') {
  // Display errors visually on screen for mobile debugging
  window.addEventListener('error', (event) => {
    console.error('[Global Error Handler]', event.error);
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:#fff;z-index:999999;padding:20px;overflow:auto;font-family:monospace;font-size:12px;';
    errorDiv.innerHTML = `
      <h2 style="color:#d32f2f;margin-bottom:16px;">App Error</h2>
      <p><strong>Message:</strong> ${event.error?.message || event.message}</p>
      <pre style="background:#f5f5f5;padding:12px;border-radius:4px;overflow:auto;">${event.error?.stack || 'No stack trace available'}</pre>
      <button onclick="location.reload()" style="margin-top:16px;padding:8px 16px;background:#0066CC;color:#fff;border:none;border-radius:4px;font-size:14px;">Reload</button>
    `;
    document.body.appendChild(errorDiv);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason);
  });

  console.log('[index.ts] Global error handlers registered');
}

// Import polyfills FIRST before any other imports (web only)
import { Platform } from 'react-native';
if (Platform.OS === 'web') {
  try {
    require('./src/polyfills/web');
    console.log('[index.ts] Web polyfills loaded');
  } catch (error) {
    console.error('[index.ts] Failed to load polyfills:', error);
  }
  // Note: require() polyfill is injected by webpack BannerPlugin at bundle top

  // Register service worker for PWA functionality
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(registration => {
          console.log('[PWA] Service worker registered:', registration.scope);
        })
        .catch(error => {
          console.error('[PWA] Service worker registration failed:', error);
        });
    });
  }
}

console.log('[index.ts] Starting app initialization...');

import { registerRootComponent } from 'expo';
import App from './App';

console.log('[index.ts] App component imported successfully');

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
try {
  console.log('[index.ts] Registering root component...');
  registerRootComponent(App);
  console.log('[index.ts] Root component registered successfully');
} catch (error) {
  console.error('[index.ts] Failed to register root component:', error);
  if (typeof window !== 'undefined') {
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:#fff;z-index:999999;padding:20px;overflow:auto;font-family:monospace;font-size:12px;';
    errorDiv.innerHTML = `
      <h2 style="color:#d32f2f;margin-bottom:16px;">Failed to Start App</h2>
      <p><strong>Error:</strong> ${error instanceof Error ? error.message : String(error)}</p>
      <pre style="background:#f5f5f5;padding:12px;border-radius:4px;overflow:auto;">${error instanceof Error ? error.stack : 'No stack trace'}</pre>
      <button onclick="location.reload()" style="margin-top:16px;padding:8px 16px;background:#0066CC;color:#fff;border:none;border-radius:4px;font-size:14px;">Reload</button>
    `;
    document.body.appendChild(errorDiv);
  }
  throw error;
}
